<template>
  <div class="nologin">
    <van-nav-bar title="title" left-text="" fixed  @click-right="onClickRight">
      <van-icon slot="left" class="iconfont icon-zuojiantou" style="font-size: 25px" @click="goBack"></van-icon>
    </van-nav-bar>
    <div class="van-content bg-fff" >
      <div class="bg-fff" >
        <img class="mainPic" src="/static/images/recharge.png" alt="">
        <div class="title">欢迎使用{{unit}}卡充值</div>
        <ul class="tishi">
          <li>充值说明：</li>
          <li>1.使用如E卡充值须先登录。</li>
          <li>2.首次使用如E卡平台的用户需先注册。</li>
          <li>3.登录或注册后，若没有自动跳转充值页面，可在个人中心进入如E卡充值。</li>
        </ul>

        <van-cell-group style="background: transparent;margin-top: 20px" >
          <van-cell style="background: transparent"><van-button size="large" class="theme-bg radius6" @click="gologin()">登录</van-button></van-cell>
          <van-cell style="background: transparent"><van-button size="large" class=" radius6" @click="goregister()">注册</van-button></van-cell>
        </van-cell-group>

      </div>
    </div>

  </div>
</template>

<script>
export default {
  name: "password",
  data() {
    return {
      oldpassword: "",
      cardNum: "",
      giveNum: "",
      password: "",
      code: "",
      codeimg: "",
      title: ""
    };
  },
  computed: {
    unit: function() {
      return this.$store.state.unitinfo.name;
    }
  },
  methods: {
    goBack: function() {
      history.back(-1);
    },
    onClickRight() {
      console.log("按钮");
    },
    gologin() {
      this.$router.push({ path: "/login" });
    },
    goregister() {
      this.$router.push({ path: "/register" });
    },
    next: function() {
      var reg = /^[0-9A-Z]{16}$/;
      if (reg.test(this.cardNum) == false) {
        this.$dialog
          .alert({
            title: "提示",
            message: "请输入正确的充值卡编号！"
          })
          .then(() => {
            // on close
          });
      } else if (this.code == "") {
        this.$dialog
          .alert({
            title: "提示",
            message: "验证码不能为空！"
          })
          .then(() => {
            // on close
          });
      } else {
      }
    },
    sendData: function() {
      var isUser = localStorage.getItem("BLHuser");
      this.$api.post(
        "user/card/recharge",
        {
          token: isUser,
          oldpassword: this.oldpassword,
          password: this.password,
          repassword: this.repassword
        },
        res => {
          if (res.data.code == "100") {
            this.$router.push({ name: "NoteLogin" });
          } else {
            if (res.data.message == "token验证失败") {
              this.$dialog
                .confirm({
                  title: "提示 ",
                  message: "您还未登录是否去登录？"
                })
                .then(() => {
                  this.$router.push({ name: "NoteLogin" });
                })
                .catch(() => {});
            } else {
              this.$toast(res.data.message);
            }
          }
        }
      );
    }
  },
  mounted() {
    this.getCode();
    var unit = localStorage.getItem("unit");
    var unitname = unit + "卡充值";
    this.title = unitname;
  }
};
</script>

<style lang="less" scoped>
.nologin {
  .mainPic {
    width: 70%;
    margin: 20px 0 0 15%;
  }
  .title {
    text-align: center;
    font-size: 2rem;
    padding-top: 20px;
  }
  .tishi {
    padding: 10px 15px;
    padding-top: 0;
    li {
      font-size: 1.4rem;
      margin-bottom: 5px;
    }
  }
  .van-cell-group {
    background-color: #fff;
  }
  .van-cell:not(:last-child)::after {
    left: 0px;
  }
  .codebox {
    line-height: 35px;
  }
  .codebox .van-button {
    height: 30px;
    line-height: 30px;
    border: none;
  }
}
</style>



// WEBPACK FOOTER //
// src/pages/user/recharge/nologin.vue